module.exports = __webpack_public_path__ + "static/img/qianqingzhengchang.50249140.png";